import { Star, Award, Crown, Gem } from 'lucide-react';
import { BLUE_CARD_IMG, SILVER_CARD_IMG, GOLD_CARD_IMG, PLATINUM_CARD_IMG } from '../../constants/images';

// Loyalty tier configurations
export const getLoyaltyTiers = (isAr) => [
  { 
    icon: Star, 
    name: isAr ? 'أزرق' : 'Blue', 
    points: '0', 
    color: '#1E9BD9', 
    benefits: isAr ? 'عضوية مجانية' : 'Free membership', 
    image: BLUE_CARD_IMG, 
    gradient: 'from-blue-500 to-cyan-500' 
  },
  { 
    icon: Award, 
    name: isAr ? 'فضي' : 'Silver', 
    points: '500', 
    color: '#94A3B8', 
    benefits: isAr ? 'خصم 5%' : '5% discount', 
    image: SILVER_CARD_IMG, 
    gradient: 'from-gray-400 to-gray-500' 
  },
  { 
    icon: Crown, 
    name: isAr ? 'ذهبي' : 'Gold', 
    points: '2000', 
    color: '#F59E0B', 
    benefits: isAr ? 'خصم 10%' : '10% discount', 
    image: GOLD_CARD_IMG, 
    gradient: 'from-amber-400 to-yellow-500' 
  },
  { 
    icon: Gem, 
    name: isAr ? 'بلاتيني' : 'Platinum', 
    points: '5000', 
    color: '#A855F7', 
    benefits: isAr ? 'خصم 15% + VIP' : '15% + VIP', 
    image: PLATINUM_CARD_IMG, 
    gradient: 'from-purple-500 to-violet-500' 
  }
];

export const LoyaltyCard = ({ tier, index, isDarkMode, isAr }) => {
  return (
    <div 
      className={`group rounded-2xl overflow-hidden transition-all duration-500 hover:scale-105 origin-top animate-slideUp ${isDarkMode ? 'bg-[#141414] border border-white/5 hover:border-white/20 hover:shadow-2xl hover:shadow-[#1E9BD9]/10' : 'bg-white border-2 border-gray-200 shadow-md hover:shadow-2xl'}`}
      style={{ animationDelay: `${index * 150}ms` }}
    >
      {/* Card Image */}
      <div className="relative h-44 overflow-hidden">
        <img 
          src={tier.image} 
          alt={tier.name} 
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className={`absolute inset-0 bg-gradient-to-t ${isDarkMode ? 'from-[#141414]' : 'from-white'} via-transparent to-transparent opacity-60`} />
        <div className="absolute bottom-3 start-4 text-white font-bold text-xl drop-shadow-lg">{tier.name}</div>
        <div className="absolute top-3 end-3 px-3 py-1.5 rounded-full bg-black/40 backdrop-blur-sm text-white text-sm font-medium">
          {tier.points}+ {isAr ? 'نقطة' : 'pts'}
        </div>
      </div>
      
      {/* Card Content */}
      <div className="p-5 text-center">
        <div 
          className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4 transition-all duration-300 group-hover:scale-110 group-hover:rotate-12"
          style={{ backgroundColor: `${tier.color}20` }}
        >
          <tier.icon className="h-7 w-7 transition-all duration-300" style={{ color: tier.color }} />
        </div>
        <h3 className={`text-xl font-semibold mb-2 ${isDarkMode ? 'text-white' : 'text-[#0f172a]'}`}>
          {tier.name}
        </h3>
        <p className="text-3xl font-bold mb-1 transition-all duration-300 group-hover:scale-110" style={{ color: tier.color }}>
          {tier.points}+
        </p>
        <p className="text-sm text-gray-500 mb-3">{isAr ? 'نقطة' : 'points'}</p>
        <div className={`pt-4 border-t ${isDarkMode ? 'border-white/10' : 'border-gray-100'}`}>
          <p className={`text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>{tier.benefits}</p>
        </div>
      </div>
    </div>
  );
};

export default LoyaltyCard;
